import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { Observable, Subscriber } from 'rxjs';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-tc-lc-mc',
  templateUrl: './tc-lc-mc.component.html',
  styleUrls: ['./tc-lc-mc.component.scss']
})
export class TCLCMCComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput') fileInputRefs!: ElementRef[];
  @ViewChild('fileUploader') fileUploader: ElementRef;
  TcLcForm: FormGroup;
  Tclcdata = [];
  dialogRef: MatDialogRef<any>;
  TCList: any;
  filterTCList: any;
  facultyList: any;
  filteredFacultyList: any;
  filteredCollegeList: any;
  CollegeList: any;
  examList: any;
  filteredExamList: any;
  courseStreamList: any;
  filteredStreamList: any;
  courseList: any;
  filteredCourseList: any;
  DestcollegeList: any;
  filteredDestCollegeList: any;
  StuId: any;
  TclcData: any;
  Table = false;
  Approved = false;
  InstId: any;
  RptCode: number;
  College = true;
  University = false;
  PayFee = false
  CgCode: any;
  filteredDestUniList: any;
  DestUniList: any;
  Status: string;
  // SaveDisabled: boolean;
  SaveDisabled = false;
  CertStatus: any;
  Other = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayDisabled = false;
  PayRecpt = false;
  DocTable = false;
  DocView = false;
  fileName: string;
  errormessage: string;
  uploadDoc: any;
  fileUploads: any;
  SavedDocument: any;
  abc: any;
  xyz: any;
  DocErr: any;
  valuesArray: any;
  ducumentList: any;
  errMsg: any;
  selectedCert: any;
  TclcDocData: any;
  UpdateDisabled: boolean;
  constructor(public umsService: UmsService,private fb: FormBuilder,public dialog: MatDialog,
    private modalPopupService: ModalpopService,private spinner: NgxSpinnerService, public router: Router,
  ) { }
  BranchId = 0;
  ngOnInit(): void {
    this.UpdateBtn = false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = false;
    this.SaveDisabled = true;
    this.Other = false;
    this.College =  true;
    this.University = false;
    this.PayFee = false;
    this.Table = false;
    this.PayDisabled = false
    this.UpdateDisabled = false;
    this.TcLcForm = this.fb.group({
      StuFaculty: new FormControl(''),
      StuExam: new FormControl(''),
      StuCourse: new FormControl(''),
      StuBranch: new FormControl(''),
      StuCollege: new FormControl(''),
      DestCollege: new FormControl(''),
      reason: new FormControl(''),
      Other: new FormControl(''),
      StuCertificate: new FormControl(''),
      arrData: this.fb.array([]),
    })
    this.getStuId()
    this.fetchTcLcMc();
    this.getSecretData();
    
  }

  getStuId() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.StuId = res.data[0].StuId
        this.RgId(res.data[0].StuId)
        this.SubjectSelectionData(res.data[0].StuId)
      }
      else{
        this.spinner.hide()
        this.SaveDisabled = true;
      }
      
    },(ERROR : HttpErrorResponse) =>
    {
      this.spinner.hide()
      this.SaveDisabled = true;
    })
  }

  SubjectSelectionData(StuId){
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
      if(res.status){
        const latestObject = res.data[res.data.length - 1];
        this.getCourseData(latestObject['SubCoId']);
        this.getCollege(latestObject['SubCgId']);
        this.getFacultyData(latestObject['SubFacId']);
        this.getExam(latestObject['SubCoId'],latestObject['SubEmId']);
        this.getExamStreamData(latestObject['SubCoId'],latestObject['SubBrId']);
      }
      else{
      }
    })
  }

  getCourseData(CoCode) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
        this.TcLcForm.controls['StuCourse'].setValue(res.data[0]['CoCode'])
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getCollege(CgCode){
    this.spinner.show()
    const payload3 = {};
    this.umsService.getCollege(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.CollegeList = res.data.filter(record => record.CgCode === CgCode);
        this.filteredCollegeList = this.CollegeList.slice();
        this.TcLcForm.controls['StuCollege'].setValue(this.CollegeList[0]['CgCode'])
        this.CgCode = CgCode
        // this.DestcollegeList = res.data.filter(record => record.CgCode != CgCode)
        // this.filteredDestCollegeList = this.DestcollegeList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  DestCollege(){
    this.spinner.show()
    const payload3 = {};
    this.umsService.getCollege(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.DestcollegeList = res.data.filter(record => record.CgCode != this.CgCode)
        this.filteredDestCollegeList = this.DestcollegeList.slice();
        this.ShowGrid()
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  GetUniversity(){
    this.spinner.show()
    const payload3 = {};
    payload3['UniCode'] = ''
    this.umsService.GetUniversity(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.DestUniList = res.data
        this.filteredDestUniList = this.DestUniList.slice();
        this.ShowGrid()
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  getFacultyData(id) {
    this.spinner.show()
    const payload = {};
    payload['FcCode'] = id;
    this.umsService.fetchFaculty(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.facultyList = res.data;
        this.filteredFacultyList = this.facultyList.slice();
        this.TcLcForm.controls['StuFaculty'].setValue(res.data[0]['FcCode'])
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  getExam(CoCode,id) {
    this.spinner.show()
    const payload2 = {};
    payload2['EmCoCode'] = CoCode;
    payload2['EmId'] = id;
    this.umsService.fetchExam(payload2).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
        this.TcLcForm.controls['StuExam'].setValue(res.data[0]['EmId'])
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  getExamStreamData(id,BrId) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = id;
    // payload['StrId'] = id;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data.filter(data => data.StrId == parseInt(BrId));
        this.filteredStreamList = this.courseStreamList.slice();
        this.TcLcForm.controls['StuBranch'].setValue(res.data[0]['StrId'])
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
   
  }


  fetchTcLcMc() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'RF';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TCList = res.data;
        this.filterTCList = this.TCList.slice();
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  Save(){
      if((this.TcLcForm.value['StuCertificate'] == 'TC' || this.TcLcForm.value['StuCertificate'] == 'MC') && this.TcLcForm.value['DestCollege'] == ""){
        const creds = this.TcLcForm.get('arrData') as FormArray;
          creds.controls.forEach(element => {
            if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
              element.get('DocumentFile').setValidators([Validators.required]);
              element.get('DocumentFile').updateValueAndValidity();
              element.get('DocumentFile').markAsTouched();
              // element.get('docFile').markAsTouched();
            } 
            else{
              const creds = this.TcLcForm.get('arrData') as FormArray;
              creds.controls.forEach(element => {
              element.get('DocumentFile').clearValidators()
              element.get('DocumentFile').updateValueAndValidity();
              })
            }
          })
        this.TcLcForm.get('DestCollege').setValidators([Validators.required]);
        this.TcLcForm.get('DestCollege').updateValueAndValidity();
        this.TcLcForm.get('DestCollege').markAsTouched();
      }
      else if((this.TcLcForm.value['StuCertificate'] == 'TC' || this.TcLcForm.value['StuCertificate'] == 'MC') && this.TcLcForm.value['DestCollege'] != ""){
        const creds = this.TcLcForm.get('arrData') as FormArray;
        creds.controls.forEach(element => {
          if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
            element.get('DocumentFile').setValidators([Validators.required]);
            element.get('DocumentFile').updateValueAndValidity();
            element.get('DocumentFile').markAsTouched();
            // element.get('docFile').markAsTouched();
          } 
          else{
            const creds = this.TcLcForm.get('arrData') as FormArray;
            creds.controls.forEach(element => {
            element.get('DocumentFile').clearValidators()
            element.get('DocumentFile').updateValueAndValidity();
            })
          this.Submit()
          }
        })
      }
      else{
        this.TcLcForm.get('DestCollege').clearValidators()
        this.TcLcForm.get('DestCollege').updateValueAndValidity();
        const creds = this.TcLcForm.get('arrData') as FormArray;
        creds.controls.forEach(element => {
            element.get('DocumentFile').clearValidators()
            element.get('DocumentFile').updateValueAndValidity();
        })
        this.Submit()
      }
  }

  Submit(){
    this.TcLcForm.controls.arrData.value
      const submitpayload = this.TcLcForm.value
      let payload = {}
      payload['StuFaculty'] = submitpayload.StuFaculty,
      payload['StuCourse'] = submitpayload.StuCourse,
      payload['StuCollege'] = submitpayload.StuCollege,
      payload['StuExam'] = submitpayload.StuExam,
      payload['StuBranch'] = submitpayload.StuBranch,
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = submitpayload.StuCertificate,
      payload['DestClg'] = submitpayload.DestCollege,
      payload['Reason'] = submitpayload.reason,
      payload['Other'] = submitpayload.Other,
      payload['FeeStatus'] = '';
      payload['CertStatus'] = 'Submitted';
      payload['StuId'] = this.StuId;
      payload['Comment'] = '';
      payload['CertScr'] = '';
      payload['StatusBy'] = sessionStorage.getItem('loginId');
      payload['DocStatus'] = 'Y';
      this.umsService.AddTclc(payload).subscribe((res) => {
        if(res.status){
          // this.spinner.hide()
          if(this.TcLcForm.controls.arrData.value.length == 0){
            this.spinner.hide()
            this.saveApplicationDetails();
            let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            // this.SaveDisabled = true;
            this.ShowGrid()
          });
          }
          else{
            this.AddTclcDoc()
          }
          
          

        }
        else{
          this.spinner.hide()
          let data = {}
          data['message'] = res.message
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        }
      },(ERROR : HttpErrorResponse) => {
        this.spinner.hide()
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );
      })
  }

  UpdateTclcDoc(){
    const submitpayload = this.TcLcForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TcLcForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
        payload['CertType'] = submitpayload.StuCertificate,
        payload['DocName'] = element.DocumentName,
        payload['FileUpload'] = this.fileUploads[index];
        payload['TclcDocId'] = element.TclcDocId
        setTimeout(() => {
          this.umsService.UpdateTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });
      
    })
    bar.then(() => {
      this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        // this.saveApplicationDetails();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ShowGrid()
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ShowGrid()
        });
      }
    });

  }

  AddTclcDoc(){
    const submitpayload = this.TcLcForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TcLcForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
        payload['CertType'] = submitpayload.StuCertificate,
        payload['DocName'] = element.DocumentName,
        payload['FileUpload'] = this.fileUploads[index];
        setTimeout(() => {
          this.umsService.AddTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });
      
    })
    bar.then(() => {
      // this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        this.saveApplicationDetails();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ShowGrid()
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ShowGrid()
        });
      }
    });

  }

  Update(){
    const submitpayload = this.TcLcForm.value
    let payload = {}
    payload['StuFaculty'] = this.TclcData[0]['StuFaculty'],
    payload['StuCourse'] = this.TclcData[0]['StuCourse'],
    payload['StuCollege'] = this.TclcData[0]['StuCollege'],
    payload['StuExam'] = this.TclcData[0]['StuExam'],
    payload['StuBranch'] = this.TclcData[0]['StuBranch'],
    payload['SnNo'] = this.TclcData[0]['SnNo'],
    payload['CertType'] = this.TclcData[0]['CertType'],
    payload['DestClg'] = submitpayload.DestCollege,
    payload['Reason'] = submitpayload.reason,
    payload['Other'] = submitpayload.Other,
    payload['FeeStatus'] = this.TclcData[0]['FeeStatus'],
    payload['CertStatus'] = 'ReSubmitted';
    payload['StuId'] = this.TclcData[0]['StuId'],
    payload['TclcId'] = this.TclcData[0]['TclcId'],
    payload['StatusBy'] = sessionStorage.getItem('loginId'),
    payload['Comment'] = '',
    payload['CertScr'] = '',
    
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.UpdateTclcDoc()
        // let data = {}
        // data['message'] = "Updated Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // // this.SaveDisabled = true;
        // this.ShowGrid();
      }
      else{
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }

  
  redirectTo(to,data): void {
    this.router.navigate([to, data]);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  ShowTable(data){
    this.TcLcForm.get('DestCollege').clearValidators()
    this.TcLcForm.get('DestCollege').updateValueAndValidity();
    this.TcLcForm.get('DestCollege').markAsUntouched()
    this.TcLcForm.controls['DestCollege'].setValue('')
    this.TcLcForm.controls['reason'].setValue('')
    this.Other = false;
    this.Table = false
    if(data == 'TC' || data == 'LC'){
      this.College =  true;
      this.University = false;
      this.DestCollege()
    }
    else if(data == 'MC'){
      this.College =  false;
      this.University = true;
      this.GetUniversity()
    }
    else if(data == 'ADMC'){
      this.College =  false;
      this.University = false;
      this.ShowGrid()
    }
    else if(data == 'TS'){
      this.selectedCert = data
      // this.ShowGrid()
      this.redirect('Transcript')
    }
    else if(data == 'PC'){
      this.selectedCert = data
      this.redirect('provisional')

    }
    
  }

  ShowGrid(){
    this.spinner.show()
    const Data = this.TcLcForm.value
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = 'All'
    payload['IsStudent'] = 1
    payload['StuId'] = this.StuId
    this.umsService.GetTclcData(payload).subscribe((res) => {
     if(res.status){
      this.spinner.hide()
      if(res.data.length > 0){
        
        // && data.CertType ==  Data.StuCertificate
        this.TclcData = res.data.filter(data => data.StuId == this.StuId && data.CertType != 'TS')
        if(this.TclcData[0]['FeeStatus'] == 'Y'){
          this.PayDisabled = true;
          this.PayRecpt = true;
        }
        else if(this.TclcData[0]['FeeStatus'] != 'Y'){
          this.PayDisabled = false;
          this.PayRecpt = false
          this.ValidateFee(this.TclcData[0]['StuId'],this.TclcData[0]['CertType'],this.TclcData[0])
        }
        if(this.TclcData != ''){
          this.getDocDetails()
          
          this.DocTable = true;
          this.DocView = true;
          if(this.TclcData[0]['CertType'] == Data.StuCertificate){
            this.SaveBtn = false;
            this.UpdateBtn = true;
          }
          else{
            this.SaveBtn = true;
            this.SaveDisabled = true;
            this.UpdateBtn = false;
          
          }

          if(this.TclcData[0]['DestClg'] != ''){
            this.TcLcForm.controls['DestCollege'].setValue(this.TclcData[0]['DestClg'])
          }
          if(this.TclcData[0]['Reason'] != ''){
            this.TcLcForm.controls['reason'].setValue(this.TclcData[0]['Reason'])
          }
          this.CertStatus = this.TclcData[0]['CertType']
          if(this.TclcData[0]['CertStatus'] == 'APR' && this.TclcData[0]['CertType'] != "ADMC"){
            this.Approved = true
            this.spinner.hide()
          }
          else{
            this.Approved = false
            this.spinner.hide()
          }
  
          // if(this.TclcData[0]['CertStatus'] == 'APPAP'){
          //   this.PayFee = true
          // }
          // else{
          //   this.PayFee = false
          // }
          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              if(this.TclcData[0]['CertType'] == "ADMC"){
                if(this.TclcData[0]['RgStatus'] == "L"){
                  this.Status = 'Application Approved'
                }
                else if(this.TclcData[0]['RgStatus'] == " "){
                  this.Status = 'Application InProcess'
                }
              }
              else{
                this.Status = 'Approved';
              }
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              if(this.TclcData[0]['CertType'] == "ADMC"){
                if(this.TclcData[0]['RgStatus'] == "L"){
                  this.Status = 'Application Approved'
                }
                else if(this.TclcData[0]['RgStatus'] == " "){
                  this.Status = 'Application InProcess'
                }
              }
              else{
                this.Status = 'Application Approved'
              }
              this.UpdateDisabled = true;
              break;  
            case "REJ":
              this.Status = 'Rejected'
              this.UpdateDisabled = false;
              break;
            case "REC":
              this.Status = 'Rectify'
              this.UpdateDisabled = false;
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted'
              this.UpdateDisabled = false;
              break;
            default:
              this.Status = this.TclcData[0]['CertStatus']
              this.UpdateDisabled = false;
              break
          }
          this.Table = true;
          this.spinner.hide()
         
        }
        else{
          this.DocTable = true;
          this.DocView = false;
          this.SaveBtn = true;
          this.SaveDisabled = false;
          this.UpdateBtn = false;
          this.Table = false
          this.TcLcForm.controls['DestCollege'].setValue('')
          this.TcLcForm.controls['reason'].setValue('')
          this.GetTcLcDocs();
          this.spinner.hide()
        }
        
      }
      else{
        this.DocTable = true;
        this.DocView = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.Table = false;
        this.UpdateBtn = false;
        this.TcLcForm.controls['DestCollege'].setValue('')
        this.TcLcForm.controls['reason'].setValue('')
        this.GetTcLcDocs();
        this.spinner.hide()
      }
      
     }
     else{
      this.SaveBtn = true;
      this.SaveDisabled = false;
      this.Table = false;
      this.UpdateBtn = false;
      this.TcLcForm.controls['DestCollege'].setValue('')
      this.TcLcForm.controls['reason'].setValue('')
      this.spinner.hide()
      this.GetTcLcDocs();
     }
    });
    
  }

  getDocDetails(){
    const creds = this.TcLcForm.controls.arrData as FormArray;
    creds.clear()
    this.DocTable = true;
    this.DocView = false;
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = this.TcLcForm.value['StuCertificate']
    this.umsService.GetTcLcDocDetails(payload).subscribe((res) => {
      if(res.status){
        this.TclcDocData = res.data.filter(record => record.StuId == this.StuId);
        if(this.TclcDocData != '' ){
          const arrayOfObjects = this.TclcDocData;
          arrayOfObjects.forEach((obj, i) => {
            const tempObj = {}
            let regex = '';
            if (obj.RegEx !== null) {
              regex = obj.RegEx
            }
              tempObj['DocumentName'] = new FormControl(obj.DocName),
              tempObj['SrNo'] = new FormControl(obj.SrNo),
              tempObj['DocNo'] = new FormControl(obj.DocNo),
              tempObj['docFile'] = new FormControl(''),
              tempObj['DocumentFile'] = new FormControl(obj.FileUpload),
              tempObj['TclcDocId'] = new FormControl(obj.TclcDocId)
            for (const key in tempObj) {
            }
            const creds = this.TcLcForm.controls.arrData as FormArray;
            creds.push(new FormGroup(tempObj));
          })
        }
        else{
          this.DocTable = false;
          this.GetTcLcDocs()
        }
       
      }
      else{
        this.DocTable = false
        this.GetTcLcDocs()
      }
    })
  }

  GetTcLcDocs(){
    const creds = this.TcLcForm.controls.arrData as FormArray;
    creds.clear()
    this.DocTable = true;
    this.DocView = false;
    const payload = {};
    // payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['ModuleType'] = this.TcLcForm.value['StuCertificate']
    this.umsService.CommonDocument(payload).subscribe((res) => {
      if(res.status){
        const arrayOfObjects = res.data;
        arrayOfObjects.forEach((obj, i) => {
          const tempObj = {}
          let regex = '';
          if (obj.RegEx !== null) {
            regex = obj.RegEx
          }
            tempObj['DocumentName'] = new FormControl(obj.DocName),
            tempObj['SrNo'] = new FormControl(obj.SrNo),
            tempObj['DocNo'] = new FormControl(obj.DocNo),
            tempObj['docFile'] = new FormControl(''),
            tempObj['DocumentFile'] = new FormControl(''),
            tempObj['TclcDocId'] = new FormControl('')
          for (const key in tempObj) {
          }
          const creds = this.TcLcForm.controls.arrData as FormArray;
          creds.push(new FormGroup(tempObj));
        })
      }
      else{
        this.DocTable = false;
      }
    })
  }

  getSecretData(){
    this.umsService.getSecretData().subscribe((res) => {
      this.InstId = res.projectPharam['ClubPartTrans']
    })
  }

  dowload(data){
    this.redirectTo('Certificate',data.CertType)

    return
    if(data.CertType == 'TC'){
      this.RptCode = 134
    }
    else if(data.CertType == 'LC'){
      this.RptCode = 135
    }
    else if(data.CertType == 'MC'){
      this.RptCode = 136
    }
    var filter: any;
    let payload1 = {}
    payload1['StudentId'] = data.StudId;
    let jsonString = JSON.stringify(payload1);
    filter = {
      // no secret data for instNo
      // "LoginId": parseInt(sessionStorage.getItem('StudentPersonalId')),
      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": this.RptCode,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": data.StuCollege,
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": data.StuCourse,
      "SnNo": data.SnNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  PayFees(){
    const Data = this.TcLcForm.value
    this.Tclcdata.push({
      "StuCourse": Data.StuCourse,
      "StuCollege": Data.StuCollege,
      "SnNo": parseInt(sessionStorage.getItem('session')),
      "CertType": Data.StuCertificate,
    })
    this.umsService.setTclcData(this.Tclcdata);
    this.redirect('TCLCFees')
  }

  RgId(StuId){
    this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SaveDisabled = true;
        this.SaveBtn = true;
      }
      else{
        this.spinner.hide()
        this.SaveDisabled = true;
        this.SaveBtn = false;
      }
      
    },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisabled = true;
      this.SaveBtn = false;
    })
  }

  Reset(){
    this.ngOnInit()
  }


  TypeUni(){
    if(this.TcLcForm.value['DestCollege'] == 'Other'){
      this.Other = true;
    }
    else{
      this.Other = false;
    }
  }

  getFeeTempData() {
     this.spinner.show();
     const payload = {};
     payload['FeeType'] = this.TcLcForm.value['StuCertificate']
     this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      if(res.status){
        this.addnewrecord(res.data[0]['TemplateCode'])
      }
     })
    }

    addnewrecord(TempCode) {
      let data = {};
      data['SnNo'] = parseInt(sessionStorage.getItem('session'))
      data['TemplateCode'] = TempCode
      const dialogRef = this.dialog.open(PaymentReceiptComponent, {
        width: '80vh',
        // height: '80vh',
        data,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
  
      });
    }

    saveApplicationDetails() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10);
      this.spinner.show()
      let payload = {};
      let Name = this.TcLcForm.value.StuCertificate
      payload['StuId'] = this.StuId;
      payload['SessionId'] = parseInt(sessionStorage.getItem('session'))
      payload['CgCode'] = this.TcLcForm.value['StuCollege']
      payload['CoCode'] = this.TcLcForm.value['StuCourse']
      payload['ApplicationName'] = Name
      payload['ApplicationSubDate'] = formattedDate
      this.umsService.saveApplicationDetails(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide()
        } else {
          this.spinner.hide()
        }
      })
    }

    onChange($event: Event, rowIndex: number) {
      const file = ($event.target as HTMLInputElement).files[0];
      const fileName = file.name;
      this.fileName = fileName;
  
      const faControl = (<FormArray>this.TcLcForm.controls['arrData']).at(rowIndex);
  
      if (file.size >= 3000000) {
        this.errormessage = "Please upload file less than 3 MB";
        let data = {
          message: this.errormessage,
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
          faControl['controls'].docFile.setValue('');
          faControl['controls'].DocumentFile.setValue('');
        });
      } else {
        this.errormessage = '';
        let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        if (ext === "pdf") {
          this.convertToBase64(file, rowIndex);
          faControl['controls'].DocumentFile.setValue(fileName);
          faControl['controls'].DocumentFile.markAsTouched();
        } else {
          faControl['controls'].docFile.setValue('');
          // faControl['controls'].docFile.markAsTouched();
          faControl['controls'].DocumentFile.setValue('');
          faControl['controls'].DocumentFile.markAsTouched();
          let data = {
            message: 'Please Upload Only PDF File',
            title: 'Information',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe(() => {
            this.fileName = '';
            ($event.target as HTMLInputElement).value = '';
          });
        }
      }
    }
  
  
    convertToBase64(file: File, rowIndex: number) {
      const observable = new Observable((subscriber: Subscriber<any>) => {
        this.readFile(file, subscriber);
      });
  
      observable.subscribe((d) => {
        this.uploadDoc = d;
        // while (this.fileUploads.length <= rowIndex) {
        //   this.fileUploads.push(null);
        // }
        if (!this.fileUploads) {
          this.fileUploads = [];  // Initialize if it's undefined
        }
        
        // Check if the rowIndex exists in the array, and if not, create a placeholder
        if (!this.fileUploads[rowIndex]) {
          this.fileUploads[rowIndex] = {}; // Initialize row if it's missing
        }
        this.fileUploads[rowIndex] = d;
        let base64Str = d.split(',');
        let filee = base64Str[1];
        const faControl = (<FormArray>this.TcLcForm.controls['arrData']).at(rowIndex);
        faControl['controls'].docFile.setValue(filee);
        faControl['controls'].DocumentFile.setValue(file.name);
  
      });
    }
  
    readFile(file: File, subscriber: Subscriber<any>) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        subscriber.next(fileReader.result);
        subscriber.complete();
      };
      fileReader.onerror = (error) => {
        subscriber.error(error);
        subscriber.complete();
      };
    }

    showbase64(e) {
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: e.value.DocumentFile
        });
    }

    ValidateFee(StuId,FeeType,Data){
      const payload = {}
      payload['StuId'] = StuId;
      payload['FeeType'] = FeeType;
      payload['SnNo'] = sessionStorage.getItem('session');
      this.umsService.ValidateFees(payload).subscribe(res => {
        this.getFeeTempData2(StuId,FeeType,Data);
      })
    }
  
    getFeeTempData2(StuId, FeeType,Data) {
       this.spinner.show();
       const payload = {};
       payload['FeeType'] = FeeType;
       this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
         this.spinner.hide();
         if (res.status) {
           this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId,Data)
           
         } else {
           this.spinner.hide();
           if (res.message == 'No Data Found') {
             
           }
   
         }
       });
     }
  
     SearchFeeDetails(TempCode, StdId, Data) {
      this.spinner.show();
      const payload = {};
      // payload['TemplateCode'] =  this.tempCo;
      payload['FeeTemplateCode'] = TempCode;
      payload['StuId'] = StdId;
      payload['FeeHistory'] = 0;
      payload['SnNo'] = sessionStorage.getItem('session')
      this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
  
  
        this.spinner.hide();
        if (res.status) {
          this.updateTC(StdId,Data)
          // let data = 0
          // res.data.forEach(element => {
          //   data += element.FeeAmt
          // });
          // if (data == res.data[0]['TotalPaidAmount']) {
          // }
          // else if (data != res.data[0]['TotalPaidAmount']) {
          // }
        } else {
          this.PayDisabled = false;
          this.PayRecpt = false;
          this.PayFee = true
        }
      });
  
    }
  
    updateTC(StdId, Data){
      let payload = {}
      payload['StuFaculty'] = Data['StuFaculty'],
      payload['StuCourse'] = Data['StuCourse'],
      payload['StuCollege'] = Data['StuCollege'],
      payload['StuExam'] = Data['StuExam'],
      payload['StuBranch'] = Data['StuBranch'],
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = Data['CertType'],
      payload['DestClg'] = Data['DestClg'],
      payload['Reason'] = Data['Reason'],
      payload['FeeStatus'] = 'Y';
      payload['CertStatus'] = 'Fees Paid';
      payload['StuId'] = Data['StuId'],
      payload['TclcId'] = Data['TclcId'],
      payload['Comment'] = '',
      payload['CertScr'] = '',
      payload['StatusBy'] = sessionStorage.getItem('loginId'),
      this.umsService.UpdateTclc(payload).subscribe((res) => {
        if(res.status){
          this.ShowGrid()
        }
      })
    }

}
